module.exports = __webpack_public_path__ + "static/media/diamond.1b14248c.png";